import React from 'react';
import {defineMessages, FormattedMessage} from 'react-intl';
import classNames from 'classnames';

import * as DisplayMode from 'constants/DisplayMode';
import {sportSortFunc} from 'rendering-commons/Sorting';
import { isRingo } from '../../../shared/domainUtils';
import { fetchFastsportToken } from '../../../actions/games/creators'
import { connect } from 'react-redux';

const messages = defineMessages({
    others: {
        id: 'menu.others',
        defaultMessage: 'Разное'
    },
    allSport: {
        id: 'menu.all_sport',
        defaultMessage: 'Все события'
    },
    popularSports: {
        id: 'menu.popular_sport',
        defaultMessage: 'Популярные события'
    },
    calendar: {
        id: 'menu.calendar',
        defaultMessage: 'Календарь'
    },
    fastSport: {
        id: 'games.fastsport',
        defaultMessage: 'Быстрый спорт'
    }
});

class Sports extends React.Component {
    static propTypes = {
        sports: React.PropTypes.object,
        isLive: React.PropTypes.bool.isRequired,
        sportElement: React.PropTypes.func.isRequired,
        showBookmarks: React.PropTypes.bool.isRequired,
        showCalendar: React.PropTypes.bool.isRequired,
        displayMode: React.PropTypes.object.isRequired,
        showAllSports: React.PropTypes.bool.isRequired,
        gridSelection: React.PropTypes.object.isRequired,
        showAllCallback: React.PropTypes.func.isRequired,
        push: React.PropTypes.func.isRequired,
        selectionToggleCallback: React.PropTypes.func.isRequired,
        selectionToggleLeagueCallback: React.PropTypes.any
    };

    static contextTypes = {
        toggleMenu: React.PropTypes.func
    };

    constructor(props) {
        super(props);

        this._onShowAllClick = this._onShowAllClick.bind(this);
        this._onCalendarClick = this._onCalendarClick.bind(this);
    }

    shouldComponentUpdate(nextProps) {
        return this.props.sports !== nextProps.sports ||
                this.props.displayMode !== nextProps.displayMode ||
                this.props.gridSelection !== nextProps.gridSelection;
    }

    _onShowAllClick(e) {
        e.preventDefault();
        this.props.showAllCallback();
    }

    _onCalendarClick() {
        this.props.push(`/live/timetable`);
    }

    openAuthModal = () => this.props.dispatch({ type: 'BEGIN_SIGNIN' })


    onFastsportClick = () => {
        const { gamblerId } = this.props
    
        if (gamblerId) {
          this.props.fetchFastsportToken(gamblerId)
        } else {
          this.openAuthModal()
        }
      }

    static renderSport(sportId, props) {
        const sportProps = {
            sportId,
            isLive: props.isLive,
            showBookmarks: props.showBookmarks,
            showMatches: props.showMatches,
            displayMode: props.displayMode,
            leagueElement: props.leagueElement,
            matchElement: props.matchElement,
            matchStatsElement: props.matchStatsElement,
            mainScoreElement: props.mainScoreElement,
            additionalScoresElement: props.additionalScoresElement,
            additionalScoreElement: props.additionalScoreElement,
            gridSelection: props.gridSelection,
            sportClickCallback: props.sportClickCallback,
            sportFavouriteClickCallback: props.sportFavouriteClickCallback,
            leagueClickCallback: props.leagueClickCallback,
            leagueFavouriteClickCallback: props.leagueFavouriteClickCallback,
            matchClickCallback: props.matchClickCallback,
            matchFavouriteClickCallback: props.matchFavouriteClickCallback,
            selectionToggleCallback: props.selectionToggleCallback,
            selectionToggleLeagueCallback: props.selectionToggleLeagueCallback
        };

        const SportElement = props.sportElement;

        return (<SportElement key={sportId} {...sportProps} />);
    }

    render() {
        const sports = this.props.sports.valueSeq().sort(sportSortFunc);

        const sportsWithLeagues = sports.filter(s => s.get('leagues').size > 0).toList();

        const {showCalendar, isLive, displayMode, showAllSports} = this.props;

        const allSports = isLive ? messages.allSport : messages.popularSports;

        const allSportsCls = (displayMode.type == DisplayMode.ALL ? 'allsport selected' : 'allsport');

        const calendarCls = (displayMode.type == DisplayMode.TIMETABLE ? 'calendars selected' : 'calendars');
        return (
          <div>
            {showAllSports && (
              <div className={allSportsCls}>
                <a href="#" className="sport-title" onClick={this._onShowAllClick}>
                  <span className={classNames('sport-icon svg-all', { 'svg-ringobet': isRingo })} />
                  <FormattedMessage {...allSports} />
                </a>
              </div>
            )}
            {sportsWithLeagues.map((s) => Sports.renderSport(s.get('id'), this.props))}
            {showCalendar && (
              <div className={calendarCls} id="menu-calendar">
                <div className="calendar-title">
                  <a className="calendar-name" onClick={this._onCalendarClick}>
                    <FormattedMessage {...messages.calendar} />
                  </a>
                  <a className="show-all">{'\u00A0'}</a>
                </div>
              </div>
            )}
          </div>
        )
    }
}


export default connect((state) => {
    const user = state.auth.get('user')
    const gamblerId = user ? user.get('gamblerId') : null
return {
    gamblerId
}
},{fetchFastsportToken})(Sports);


// WEBPACK FOOTER //
// ./js/sport-betting/components/menu/Sports.jsx